import * as Handlebars from 'handlebars/runtime'
module.exports = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<li>\n	<label>\n		<input type=\"checkbox\" name=\"frequencies\" value=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\" data-label=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"label") : depth0), depth0))
    + "\"><svg>					<use xlink:href=\"#checkbox-inner-shadow\"/>					<use class=\"unchecked-unfocused\" xlink:href=\"#icon-checkbox-unchecked-unfocused\"/>					<use class=\"unchecked-focused\" xlink:href=\"#icon-checkbox-unchecked-focused\"/>					<use class=\"checked-unfocused\" xlink:href=\"#icon-checkbox-checked-unfocused\"/>					<use class=\"checked-focused\" xlink:href=\"#icon-checkbox-checked-focused\"/>					<use class=\"checkmark\" xlink:href=\"#checkbox-check\"/>				</svg>\n		<span class=\"label-text\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"label") : depth0), depth0))
    + "</span>\n	</label>\n</li>\n";
},"useData":true})